import { createRoot } from 'react-dom/client';
import axios from 'axios';

import './ui-kit.css';
import './ds-color-primitives.css';
import './ds-spacing-primitives.css';
import './ds-colors.css';
import './ds-typography.css';
import './index.css';

import * as serviceWorker from './serviceWorker';
import { defaultConfig, globalConfig, globalConfigUrl } from './configuration/config';
import { api } from './api';
import { MixpanelProvider } from './wrappers/mixpanel';
import { initSentry } from './lib/sentry';
import { initHotjar } from './lib/hotjar';
import { MaintenanceRoute } from './routes/maintenance/maintenance.route';
import { WorkOSAuthProvider } from './workos-auth';
import { AuthenticatedApp } from './AuthenticatedApp';

axios
  .get(`${window.location.origin}/${globalConfigUrl}`, {
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  })
  .then((response) => {
    globalConfig.config = response.data;

    if (process.env.NODE_ENV !== 'development') {
      initSentry();
    }

    if (globalConfig.config.environment === 'production' && globalConfig.config.hotjar) {
      initHotjar(globalConfig.config.hotjar);
    }

    api.init();
  })
  .catch((e) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(
        `Failed to load global configuration from '${globalConfigUrl}', using the default configuration instead:`,
        defaultConfig,
      );
      globalConfig.config = defaultConfig;
    } else {
      const errorMessage =
        'Error while fetching global config, the App wil not be rendered. (This is NOT a React error.)';
      console.error(errorMessage, `Have you provided the config file '${globalConfigUrl}'?`, e);
      throw new Error(errorMessage);
    }
  })
  .then(async () => {
    const root = createRoot(document.getElementById('root')!);

    try {
      const { data: status } = await axios.get(globalConfig.config.baseApiUrl);

      root.render(
        <WorkOSAuthProvider>
          <MixpanelProvider>
            {status.isInMaintenance ? (
              <MaintenanceRoute />
            ) : (
              <AuthenticatedApp />
            )}
          </MixpanelProvider>
        </WorkOSAuthProvider>,
      );
    } catch (error) {
      console.error('Failed to fetch app status:', error);
      root.render(
        <WorkOSAuthProvider>
          <MixpanelProvider>
            <AuthenticatedApp />
          </MixpanelProvider>
        </WorkOSAuthProvider>,
      );
    }
  })
  .catch((error) => {
    console.error('Unhandled error during app initialization:', error);
    const root = createRoot(document.getElementById('root')!);
    root.render(
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h1>Application Error</h1>
        <p>Failed to initialize the application. Please refresh the page.</p>
        {process.env.NODE_ENV === 'development' && <pre>{JSON.stringify(error, null, 2)}</pre>}
      </div>,
    );
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
